import 'Config/ReactotronConfig'
import React from 'react'
import ReactDOM from 'react-dom'
// import registerServiceWorker from './registerServiceWorker'
import * as Sentry from '@sentry/browser'
import './semantic/dist/semantic.min.css'
import './index.css'
import App from './App'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://07a437117e6144dea9e2538a82763924@sentry.io/1353445'
  })
}

const rootEl = document.getElementById('root')
ReactDOM.render(<App />, rootEl)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(<NextApp />, rootEl)
  })
}
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js